import Table from "@mui/joy/Table";
import React from "react";

interface DistributionRow {
  label: string;
  value: number;
}

const transformDataToRow = (data: { [key: string]: number }): DistributionRow[] => {
  const rows: DistributionRow[] = [];

  Object.entries(data).forEach(([concept, count]) => {
    rows.push({
      label: concept,
      value: count,
    });
  });

  return rows;
};

interface DistributionTableProps {
  firstColumnName: string;
  data: { [key: string]: number };
}

const DistributionTable: React.FC<DistributionTableProps> = ({ firstColumnName, data }) => {
  const rows = React.useMemo(() => transformDataToRow(data), [data]);

  return (
    <Table
      aria-label={`${firstColumnName} distribution table`}
      size="sm"
      sx={{ "& tr > *:not(:first-child)": { textAlign: "right" } }}
    >
      <thead>
        <tr>
          <th style={{ width: "40%" }}>{firstColumnName}</th>
          <th
            style={{
              textAlign: "right",
              width: "30%",
            }}
          >
            Number of patients
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((x) => (
          <tr key={x.label}>
            <td>{x.label}</td>
            <td>{x.value}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DistributionTable;
